import { FC, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import { SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID } from './modal/reschedule/ScheduledMessagesRescheduleModal.constants';
import useScheduledMessagesRescheduleModal from './modal/reschedule/useScheduledMessagesRescheduleModal';

const RescheduleScheduledMessageModal: FC = () => {
  const { key } = useParams();
  const hasInit = useRef(false);
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const { openRescheduleScheduledMessagesModal } =
    useScheduledMessagesRescheduleModal();

  useEffect(() => {
    if (
      key &&
      !activeModals[SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID] &&
      !hasInit.current
    ) {
      openRescheduleScheduledMessagesModal({ scheduledMessageUid: key });
      hasInit.current = true;
    }
  }, [key, activeModals, openRescheduleScheduledMessagesModal]);

  useEffect(() => {
    return () => {
      if (hasInit.current) {
        closeModal(SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID);
        hasInit.current = false;
      }
    };
  }, [closeModal]);

  return null;
};

export default RescheduleScheduledMessageModal;
